
import appTheme from './index';

const lightModePuls = {
    ...appTheme,
    palette: {
      primary: {
        main: '#ff0000',
      },
      action:{
        selected: 'rgba(255, 0, 0,0.5)',
        hover: 'rgba(255,0,0,0.1)'
      },
      scrollbar:{
        main:"#ff0000"
      }
    },

  } 

 export default lightModePuls;